// src/components/extraction/FilePreview.jsx
// Zeigt eine kleine Vorschau der ausgewählten Datei: Bild inline, PDF nativ per
// <embed> - aber nur auf Desktop-Breakpoints. Auf Mobilgeräten (und vielen
// mobilen Browsern) zeigt die native PDF-Einbettung nur einen leeren Platzhalter
// mit "Öffnen"-Link, deshalb dort weiterhin nur der Hinweistext.
//
// #zoom=page-width im URL-Fragment weist den eingebauten PDF-Viewer an, initial auf
// Seitenbreite zu zoomen statt (wie standardmäßig) auf "ganze Seite einpassen" - sonst
// bleibt in einer hohen, schmalen Spalte viel schwarzer Rand übrig. Das ist kein offizieller
// Web-Standard, sondern eine von Chromium-Browsern (Chrome/Edge) unterstützte De-facto-
// Konvention; andere Browser ignorieren den Parameter ggf. und zeigen den Standard-Zoom.
import React, { useEffect, useState } from 'react'
import useIsDesktop from './useIsDesktop'

function FilePreview ({ file }) {
  const isDesktop = useIsDesktop()
  const [previewUrl, setPreviewUrl] = useState(null)

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null)
      return undefined
    }
    const url = URL.createObjectURL(file)
    setPreviewUrl(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  if (!file || !previewUrl) return null

  const extension = file.name.split('.').pop()?.toLowerCase()
  const isImage =
    file.type.startsWith('image/') || ['png', 'jpg', 'jpeg'].includes(extension)
  const isPdf = file.type === 'application/pdf' || extension === 'pdf'

  return (
    <div className='file-preview'>
      {isImage && (
        <img src={previewUrl} alt={file.name} className='file-preview-image' />
      )}
      {isPdf && isDesktop && (
        <embed
          src={`${previewUrl}#zoom=page-width`}
          type='application/pdf'
          className='file-preview-pdf'
        />
      )}
      {isPdf && !isDesktop && (
        <p className='file-preview-fallback'>
          PDF ausgewählt – keine Vorschau auf Mobilgeräten verfügbar.
        </p>
      )}
      {!isImage && !isPdf && (
        <p className='file-preview-fallback'>
          Keine Vorschau für diesen Dateityp verfügbar.
        </p>
      )}
    </div>
  )
}

export default FilePreview
